const Layout = () => import('@/layout/index.vue')

export default {
    path: '/setting',
    component: Layout,
    redirect: '/setting/carousel',
    name: 'Setting',
    meta: {
        title: '系统设置',
        icon: 'setting'
    },
    children: [
        // {
        //     path: 'test',
        //     name: 'settingTest',
        //     component: () => import('@/views/setting/test/index.vue'),
        //     meta: {
        //         title: 'Test',
        //         icon: 'setting-article-info'
        //     }
        // },
        {
            path: 'region',
            name: 'SettingRegion',
            component: () => import('@/views/setting/region/index.vue'),
            meta: {
                title: '国家',
                icon: 'setting-region',
                auth: ['setting.region']
            }
        },
        {
            path: 'carousel',
            name: 'SettingCarousel',
            component: () => import('@/views/setting/carousel/index.vue'),
            meta: {
                title: '走马灯',
                icon: 'setting-carousel',
                auth: ['setting.carousel']
            }
        },
        {
            path: 'quickLink',
            name: 'SettingQuickLink',
            component: () => import('@/views/setting/quickLink/index.vue'),
            meta: {
                title: '金刚区-首页',
                icon: 'setting-quick-link',
                auth: ['setting.quickLink']
            }
        },
        {
            path: 'workbench',
            name: 'SettingWorkbench',
            component: () => import('@/views/setting/workbench/index.vue'),
            meta: {
                title: '金刚区-工作台',
                icon: 'setting-workbench',
                auth: ['setting.workbench']
            }
        },
        {
            path: 'network',
            name: 'SettingNetwork',
            component: () => import('@/views/setting/network/index.vue'),
            meta: {
                title: '网络配置',
                icon: 'setting-network',
                auth: ['setting.network']
            }
        },
        {
            path: 'videoCategory',
            name: 'SettingVideoCategory',
            component: () => import('@/views/setting/videoCategory/index.vue'),
            meta: {
                title: '视频分类',
                icon: 'setting-video-category',
                auth: ['setting.videoCategory']
            }
        },
        {
            path: 'productCategory',
            name: 'SettingProductCategory',
            component: () => import('@/views/setting/productCategory/index.vue'),
            meta: {
                title: '商品分类',
                icon: 'setting-product-category',
                auth: ['setting.productCategory']
            }
        },
        {
            path: 'newsType',
            name: 'SettingNewsType',
            component: () => import('@/views/setting/newsType/index.vue'),
            meta: {
                title: '资讯类型',
                icon: 'setting-news-type',
                auth: ['setting.newsType']
            }
        },
        {
            path: 'newsPush',
            name: 'SettingNewsPush',
            component: () => import('@/views/setting/newsPush/index.vue'),
            meta: {
                title: '资讯推送',
                icon: 'setting-news-push',
                auth: ['setting.newsPush']
            }
        },
        {
            path: 'articleType',
            name: 'SettingArticleType',
            component: () => import('@/views/setting/articleType/index.vue'),
            meta: {
                title: '文章类型',
                icon: 'setting-article-type',
                auth: ['setting.articleType']
            }
        },
        {
            path: 'articleInfo',
            name: 'SettingArticleInfo',
            component: () => import('@/views/setting/articleInfo/index.vue'),
            meta: {
                title: '文章信息',
                icon: 'setting-article-info',
                auth: ['setting.articleInfo']
            }
        },
        {
            path: 'signIn',
            name: 'SettingSignIn',
            component: () => import('@/views/setting/signin/index.vue'),
            meta: {
                title: '签到任务',
                icon: 'setting-sign-in',
                auth: ['setting.signin']
            }
        },
        {
            path: 'interface',
            name: 'SettingInterface',
            component: () => import('@/views/setting/interface/index.vue'),
            meta: {
                title: '接口信息',
                icon: 'setting-interface',
                auth: ['setting.interface']
            }
        },
        {
            path: 'task',
            name: 'SettingTask',
            component: () => import('@/views/setting/task/index.vue'),
            meta: {
                title: '任务管理',
                icon: 'setting-task',
                auth: ['setting.task']
            }
        },
        {
            path: 'goods',
            name: 'SettingGoods',
            component: () => import('@/views/setting/goods/index.vue'),
            meta: {
                title: '商品管理',
                icon: 'setting-goods',
                auth: ['setting.goods']
            }
        },

        {
            path: 'level',
            name: 'SettingLevel',
            component: () => import('@/views/setting/level/index.vue'),
            meta: {
                title: '会员等级',
                icon: 'setting-level',
                auth: ['setting.level']
            }
        },
        {
            path: 'package',
            name: 'SettingPackage',
            component: () => import('@/views/setting/package/index.vue'),
            meta: {
                title: '套餐信息',
                icon: 'setting-package',
                auth: ['setting.package']
            }
        },
        {
            path: 'versions',
            name: 'SettingVersions',
            component: () => import('@/views/setting/versions/index.vue'),
            meta: {
                title: '版本信息',
                icon: 'setting-versions',
                auth: ['setting.versions']
            }
        },
        {
            path: 'versionChannel',
            name: 'SettingVersionChannel',
            component: () => import('@/views/setting/versionChannel/index.vue'),
            meta: {
                title: '版本渠道',
                icon: 'setting-version-channel',
                auth: ['setting.versionChannel']
            }
        },
        {
            path: 'parameter',
            name: 'SettingParameter',
            component: () => import('@/views/setting/parameter/index.vue'),
            meta: {
                title: '系统参数',
                icon: 'setting-parameter',
                auth: ['setting.parameter']
            }
        },
        {
            path: 'invitationCode',
            name: 'SettingInvitationCode',
            component: () => import('@/views/setting/invitationCode/index.vue'),
            meta: {
                title: '系统邀请码',
                icon: 'setting-invitation-code',
                auth: ['setting.invitationCode']
            }
        }
    ]
}
